/**
 * Formatta un timestamp in millisecondi nel formato mm:ss.
 * Se il valore è negativo o zero, restituisce "0:00".
 */
export function formatTime(ms: number): string {
  if (ms <= 0) return '0:00';
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}